import classnames from 'classnames';

export default (base, mods = [], rest) =>
  classnames(
    base,
    mods.map((mod) => `${base}--${mod}`),
    rest
  );
